import React from 'react';
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer, Legend,
} from 'recharts';
import {HolidayType} from "../../../domains/models/holiday";

interface PieData {
    name: HolidayType;
    count: number;
}

interface HolidayPieChartProps {
    data: PieData[];
}

const PIE_COLORS = ['var(--holiday-national)', 'var(--holiday-optional)', 'var(--holiday-restricted)', 'var( --holiday-mandatory)', 'var( --holiday-emergency)'];

function HolidayPieChart(props: HolidayPieChartProps) {

    return (
        <div className={'pn-holiday__cal-chart-card'}>
            <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                    <Pie
                        data={props.data}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={80}
                        paddingAngle={3}
                        dataKey="count"
                        stroke="none"
                    >
                        {props.data.map((entry: any, index: number) => (
                            <Cell key={`cell-${index}`} fill={PIE_COLORS[index % PIE_COLORS.length]}/>
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            background: '#FFFFFF',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#0f172a',
                        }}
                    />
                    <Legend
                        iconType="circle"
                        iconSize={8}
                        wrapperStyle={{fontSize: '12px', color: '#64748b'}}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default HolidayPieChart;